import React from 'react'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import { makeStyles } from '@material-ui/core'

export default function ConfirmationDialog({ isShowing, buttonText, message,callback, title,disabled }) {
    const [open, setOpen] = React.useState(isShowing)
    const useStyles = makeStyles((theme) => ({
        cardHeader: {
            "background": theme.palette.primary.main,
            "color": theme.palette.primary.contrastText
        }
    }))
    const classes = useStyles()
    const handleClickOpen = () => {
        setOpen(true)
    }

    const handleClose = () => {
        setOpen(false)
    }

    return (
        <span>
            <Button size="small" color="primary" onClick={handleClickOpen}    disabled={disabled}>{buttonText}</Button>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title" className={classes.cardHeader}>{title}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {message}
          </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Cancel
          </Button>
                    <Button onClick={callback} color="primary" autoFocus>
                        OK
          </Button>
                </DialogActions>
            </Dialog>
        </span>
    )
}